module.exports = __webpack_public_path__ + "img/phone.e56f7b6e.svg";